import React, { useEffect, useState, createElement } from 'react';
import { Flame, CheckCircle2, ShieldCheck, Zap, Lock, Clock, Sparkles, MessageSquare, AlertTriangle, BookOpen, Target, Gift, Frown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouOfferPage() {
  // 15-minute countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Offer-View');
    // Countdown
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-amber-400 selection:text-black" data-id="element-4097">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4098">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4099" />
      </noscript>

      {/* Urgency Top Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-black py-2.5 px-4 shadow-lg" data-id="element-4100">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-4101">
          <Flame className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" data-id="element-4102" />
          <p className="text-[11px] md:text-sm font-black uppercase tracking-wide" data-id="element-4103">
            OFERTA EXCLUSIVA — EXPIRA EN{' '}
            <span className="font-mono bg-black text-amber-400 px-2 py-0.5 rounded ml-1 tabular-nums" data-id="element-4104">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
      </div>

      {/* Registration Incomplete Alert — keeps visitors on page */}
      <div className="bg-red-600 py-2 px-4" data-id="element-4105">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-4106">
          <AlertTriangle className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-4107" />
          <p className="text-white font-bold text-[11px] md:text-sm uppercase tracking-tight leading-tight" data-id="element-4108">
            Tu registración al webinar no está completa aún
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12 lg:py-16" data-id="element-4109">
        {/* Hero Section */}
        <section className="text-center mb-10 md:mb-14 lg:mb-16" data-id="element-4110">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5 md:mb-6" data-id="element-4111">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-4112" />
            <span className="text-amber-400 text-[11px] md:text-sm font-bold uppercase tracking-widest" data-id="element-4113">
              Solo durante los próximos 15 minutos
            </span>
          </div>

          <h1 className="text-[26px] md:text-4xl lg:text-5xl font-black leading-[1.15] tracking-tight mb-5 md:mb-6" data-id="element-4114">
            Antes de Cerrar Esta Página...
            <br data-id="element-4115" />
            <span className="text-amber-400" data-id="element-4116">
              Lleva los 200 Mensajes EXACTOS
            </span>{' '}
            Que Mis Alumnos Están Usando Para Cerrar Clientes Locales —{' '}
            <span className="text-white underline decoration-amber-400 decoration-4 underline-offset-4" data-id="element-4117">
              Por Solo $27
            </span>
          </h1>

          <div className="flex justify-center mb-6 md:mb-8" data-id="element-4118">
            <img src="https://cdn.magicpatterns.com/uploads/4n1XFjTikJYFAFB3YJ15PL/Libro_200_Mensajes.png" alt="200 Mensajes de WhatsApp para Cerrar Clientes — mockup del libro" className="w-full max-w-lg md:max-w-2xl h-auto rounded-2xl shadow-[0_25px_70px_-15px_rgba(0,0,0,0.7)] ring-1 ring-white/10" data-id="element-4119" />
          </div>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-4120">
            El manual completo con{' '}
            <span className="text-white font-bold" data-id="element-4121">
              200 mensajes WhatsApp listos para copiar y pegar
            </span>{' '}
            — organizados por nicho y situación — para que ejecutes desde el{' '}
            <span className="text-amber-400 font-bold" data-id="element-4122">JUEVES</span> en cuanto
            termine el webinar.
          </p>
        </section>

        {/* Problem Section */}
        <section className="mb-10 md:mb-14" data-id="element-4123">
          <div className="bg-gradient-to-br from-red-950/40 to-[#0a0e1a] border border-red-500/20 rounded-2xl p-6 md:p-8 lg:p-10" data-id="element-4124">
            <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-4125">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-red-500/10 border border-red-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-4126">
                <Frown className="w-5 h-5 md:w-6 md:h-6 text-red-400" data-id="element-4127" />
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-4128">
                El Problema Real
              </h2>
            </div>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 md:pl-[60px]" data-id="element-4129">
              <p data-id="element-4130">Mira, te soy directo:</p>
              <p data-id="element-4131">
                El jueves vas a salir del webinar emocionado. Vas a querer
                mandar tu primer mensaje. Vas a abrir WhatsApp...
              </p>
              <p data-id="element-4132">Y te vas a quedar mirando la pantalla en blanco pensando:</p>
              <p className="text-white italic border-l-2 border-amber-400 pl-4 my-5" data-id="element-4133">
                "¿Qué le escribo a este dentista? ¿Cómo abro la conversación sin
                sonar a vendedor desesperado? ¿Y si me ignora?"
              </p>
              <p data-id="element-4134">
                Eso le pasa al{' '}
                <span className="text-red-400 font-bold" data-id="element-4135">80%</span> de los que
                toman acción después de un webinar. Y por eso al{' '}
                <span className="text-red-400 font-bold" data-id="element-4136">
                  80% NO les funciona.
                </span>
              </p>
              <p className="text-white font-bold" data-id="element-4137">
                No es que el sistema sea malo. Es que NO tienen el copy
                correcto.
              </p>
            </div>
          </div>
        </section>

        {/* Solution Section */}
        <section className="mb-10 md:mb-14" data-id="element-4138">
          <div className="bg-gradient-to-br from-amber-950/40 to-[#0a0e1a] border border-amber-500/30 rounded-2xl p-6 md:p-8 lg:p-10" data-id="element-4139">
            <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-4140">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-4141">
                <Zap className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-4142" />
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-4143">
                La Solución
              </h2>
            </div>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 md:pl-[60px]" data-id="element-4144">
              <p data-id="element-4145">Por eso compilé este manual:</p>
              <ul className="space-y-3" data-id="element-4146">
                <li className="flex items-start gap-3" data-id="element-4147">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-4148">
                    <MessageSquare className="w-4 h-4 text-amber-400" data-id="element-4149" />
                  </div>
                  <span className="pt-1" data-id="element-4150">
                    <span className="text-white font-bold" data-id="element-4151">
                      200 mensajes EXACTOS
                    </span>
                    , palabra por palabra
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-4152">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-4153">
                    <Target className="w-4 h-4 text-amber-400" data-id="element-4154" />
                  </div>
                  <span className="pt-1" data-id="element-4155">
                    Organizados por{' '}
                    <span className="text-white font-bold" data-id="element-4156">6 nichos</span> (los
                    más rentables en USA)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-4157">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-4158">
                    <Zap className="w-4 h-4 text-amber-400" data-id="element-4159" />
                  </div>
                  <span className="pt-1" data-id="element-4160">
                    Y por{' '}
                    <span className="text-white font-bold" data-id="element-4161">5 situaciones</span>{' '}
                    (primer contacto, follow-up, objeciones, cierre)
                  </span>
                </li>
              </ul>
              <p className="pt-2" data-id="element-4162">Cada mensaje tiene:</p>
              <ul className="space-y-2" data-id="element-4163">
                <li className="flex items-start gap-2" data-id="element-4164">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-4165" />
                  <span data-id="element-4166">Cuándo usarlo</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4167">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-4168" />
                  <span data-id="element-4169">Variables editables ([NOMBRE], [CIUDAD], etc.)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4170">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-4171" />
                  <span data-id="element-4172">Tip de psicología detrás de por qué funciona</span>
                </li>
              </ul>
              <p className="text-white font-bold pt-3" data-id="element-4173">
                Solo abres, eliges el mensaje correcto, reemplazas variables, y
                mandas.{' '}
                <span className="text-amber-400" data-id="element-4174">10 segundos por mensaje.</span>
              </p>
            </div>
          </div>
        </section>

        {/* What's Included Section */}
        <section className="mb-10 md:mb-14" data-id="element-4175">
          <div className="text-center mb-8 md:mb-10" data-id="element-4176">
            <span className="inline-block bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 px-4 py-1.5 rounded-full text-[11px] md:text-sm font-bold tracking-widest uppercase mb-4" data-id="element-4177">
              Lo Que Incluye
            </span>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-4178">
              Todo Lo Que Recibes Hoy
            </h2>
          </div>

          {/* Niches */}
          <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-6 md:p-8 mb-5" data-id="element-4179">
            <div className="flex items-start gap-3 md:gap-4 mb-5" data-id="element-4180">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-4181">
                <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-4182" />
              </div>
              <h3 className="text-lg md:text-2xl font-black text-white leading-tight pt-1" data-id="element-4183">
                Los 6 Nichos Más Rentables{' '}
                <span className="text-amber-400 block md:inline" data-id="element-4184">
                  (25 mensajes c/u)
                </span>
              </h3>
            </div>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-300 text-sm md:text-base md:pl-[60px]" data-id="element-4185">
              {['Dentistas y clínicas médicas', 'Salones de belleza, barberías, spas', 'Restaurantes y bares', 'Abogados, contadores, notarios', 'Gimnasios y studios de fitness', 'Talleres mecánicos y servicios automotrices'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-4186">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-4187" />
                  <span data-id="element-4188">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Situations */}
          <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-6 md:p-8 mb-5" data-id="element-4189">
            <div className="flex items-start gap-3 md:gap-4 mb-5" data-id="element-4190">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-4191">
                <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-4192" />
              </div>
              <h3 className="text-lg md:text-2xl font-black text-white leading-tight pt-1" data-id="element-4193">
                Las 5 Situaciones Clave{' '}
                <span className="text-amber-400 block md:inline" data-id="element-4194">
                  (10 mensajes c/u)
                </span>
              </h3>
            </div>
            <ul className="space-y-3 text-gray-300 text-sm md:text-base md:pl-[60px]" data-id="element-4195">
              {[{
              title: 'Primer contacto cold',
              desc: 'cómo abrir sin sonar a spam'
            }, {
              title: 'Cuando no responden',
              desc: 'cómo hacer follow-up sin molestar'
            }, {
              title: 'Cuando piden precio en WhatsApp',
              desc: 'cómo pivotar a llamada'
            }, {
              title: 'Manejo de objeciones',
              desc: '"está caro", "ya tengo web", etc.'
            }, {
              title: 'Cierre y agendamiento',
              desc: 'cómo mover a llamada SIN perder al lead'
            }].map(item => <li key={item.title} className="flex items-start gap-2.5" data-id="element-4196">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-4197" />
                  <span data-id="element-4198">
                    <span className="text-white font-semibold" data-id="element-4199">
                      {item.title}
                    </span>{' '}
                    <span className="text-gray-400" data-id="element-4200">({item.desc})</span>
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Bonuses */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-4201">
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-700/5 border border-amber-500/30 rounded-2xl p-5 md:p-7" data-id="element-4202">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-4203">
                <div className="w-9 h-9 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-4204">
                  <Gift className="w-4 h-4 text-amber-400" data-id="element-4205" />
                </div>
                <span className="text-amber-400 font-black text-[11px] md:text-xs uppercase tracking-wider" data-id="element-4206">
                  Bonus #1
                </span>
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2 leading-snug" data-id="element-4207">
                Las 5 Reglas de Oro del WhatsApp Marketing
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-4208">
                Sin esto, los 200 mensajes no funcionan.
              </p>
            </div>
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-700/5 border border-amber-500/30 rounded-2xl p-5 md:p-7" data-id="element-4209">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-4210">
                <div className="w-9 h-9 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-4211">
                  <Gift className="w-4 h-4 text-amber-400" data-id="element-4212" />
                </div>
                <span className="text-amber-400 font-black text-[11px] md:text-xs uppercase tracking-wider" data-id="element-4213">
                  Bonus #2
                </span>
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2 leading-snug" data-id="element-4214">
                Plantilla editable en Google Docs
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-4215">
                Para que personalices y guardes tus versiones favoritas.
              </p>
            </div>
          </div>
        </section>

        {/* Unified Value + CTA + Pricing Section */}
        <section className="mb-8" data-id="element-4216">
          <div className="bg-gradient-to-br from-[#0f1729] to-[#0a0e1a] border-2 border-amber-500/40 rounded-2xl p-6 md:p-10 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-4217">
            {/* Value Anchor */}
            <div className="text-center" data-id="element-4218">
              <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-4 md:mb-5" data-id="element-4219">
                Valor Real vs Inversión Hoy
              </h2>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-4220">
                Si pagaras a un copywriter por crear estos 200 mensajes desde
                cero, te cobrarían entre{' '}
                <span className="text-white font-bold" data-id="element-4221">
                  $50–$100 por mensaje.
                </span>
              </p>
              <div className="flex flex-col items-center gap-1" data-id="element-4222">
                <span className="text-gray-500 text-[11px] md:text-sm uppercase tracking-widest" data-id="element-4223">
                  Valor en el mercado
                </span>
                <span className="text-3xl md:text-5xl font-black text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-4224">
                  $10,000 – $20,000
                </span>
              </div>
              <p className="text-gray-400 text-sm md:text-base mt-5 max-w-xl mx-auto" data-id="element-4225">
                Se paga solo con el{' '}
                <span className="text-white font-bold" data-id="element-4226">PRIMER cliente</span> que
                cierres usando UNO solo de estos mensajes.
              </p>
            </div>

            {/* Divider */}
            <div className="my-7 md:my-8 border-t border-dashed border-amber-500/20" data-id="element-4227" />

            {/* Price summary */}
            <div className="text-center mb-7" data-id="element-4228">
              <div className="flex justify-center mb-6" data-id="element-4229">
                <img src="https://cdn.magicpatterns.com/uploads/6ftzgqwNdfAsRjM99tDYEx/Libro_200_Mensajes.png" alt="200 Mensajes de WhatsApp para Cerrar Clientes" className="w-full max-w-md md:max-w-xl h-auto rounded-xl shadow-[0_20px_60px_-10px_rgba(0,0,0,0.6)] ring-1 ring-white/10" data-id="element-4230" />
              </div>
              <p className="text-amber-400 text-[11px] md:text-sm uppercase tracking-widest font-bold mb-2" data-id="element-4231">
                Hoy lo llevas por
              </p>
              <p className="text-6xl md:text-8xl font-black text-amber-400 mb-2 leading-none tabular-nums" data-id="element-4232">
                $27{' '}
                <span className="text-lg md:text-2xl text-gray-500 font-medium align-top" data-id="element-4233">
                  USD
                </span>
              </p>
              <p className="text-amber-400 text-sm md:text-base font-semibold" data-id="element-4234">
                Pago único · Sin suscripción
              </p>
            </div>

            {/* Main CTA Button */}
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" target="_blank" rel="noopener noreferrer" className="group block w-full" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
            }
          }} data-id="element-4235">
              <button className="relative w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-black text-sm md:text-xl uppercase tracking-tight py-5 md:py-6 px-4 md:px-6 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-4236">
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-4237">
                  <MessageSquare className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-4238" />
                  <span data-id="element-4239">SÍ, QUIERO LOS 200 MENSAJES POR $27</span>
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-4240" />
              </button>
            </a>

            {/* Microcopy */}
            <div className="mt-5 flex items-center justify-center gap-x-4 gap-y-2 flex-wrap text-[11px] md:text-sm text-gray-400" data-id="element-4241">
              <span className="flex items-center gap-1.5" data-id="element-4242">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4243" />
                Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4244">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4245" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4246">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4247" />
                Pago seguro con tarjeta
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4248">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4249" />
                Acceso de por vida
              </span>
            </div>

            {/* Downsell link — right under the CTA so users don't miss the next step */}
            <div className="text-center mt-4" data-id="element-4250">
              <Link to="/thank-you-downsale" className="text-white hover:text-gray-200 text-sm md:text-base underline underline-offset-4 transition-colors" data-id="element-4251">
                No gracias, solo quiero ir al webinar →
              </Link>
            </div>

            {/* Guarantee Block */}
            <div className="mt-7 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center gap-4" data-id="element-4252">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-500/10 rounded-full flex items-center justify-center border border-emerald-500/20 flex-shrink-0" data-id="element-4253">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-4254" />
              </div>
              <div className="text-center md:text-left" data-id="element-4255">
                <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-4256">
                  Garantía Incondicional de 7 Días
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-4257">
                  Si no encuentras valor en el manual, te devuelvo el 100% de tu
                  inversión. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust footer note */}
        <div className="text-center text-gray-600 text-xs md:text-sm pt-6 flex items-center justify-center gap-1.5" data-id="element-4258">
          <Clock className="w-4 h-4 flex-shrink-0" data-id="element-4259" />
          <span data-id="element-4260">
            Esta oferta no estará disponible después de salir de esta página.
          </span>
        </div>
      </main>

      <Footer data-id="element-4261" />
    </div>;
}